var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.916,
    height: 32.559,
    viewBox: "0 0 109.916 32.559",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-79"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-13288",
    d: "M0,5.914l2.613-.456a12.518,12.518,0,0,1,.162,2.48,6.275,6.275,0,0,1,4.8-2.382,5.564,5.564,0,0,1,4.344,2.023c1.211,1.5,1.8,3.5,1.8,6.406A9.821,9.821,0,0,1,12.414,19.6a5.789,5.789,0,0,1-5.032,2.971,6.352,6.352,0,0,1-4.474-1.893V31.128l-2.547.487V9.406A11.7,11.7,0,0,0,0,5.914ZM2.908,18.323a5.473,5.473,0,0,0,3.983,2.125,3.744,3.744,0,0,0,3.429-2.026,9.412,9.412,0,0,0,.687-4.116,12.163,12.163,0,0,0-.752-4.672,3.262,3.262,0,0,0-3.005-1.8,5.565,5.565,0,0,0-4.342,2.29Z",
    transform: "translate(0 0.944)",
    fill: "#3d3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13290",
    d: "M15.038,6.153l2.548-.686a5.856,5.856,0,0,1,.523,2.647A5.9,5.9,0,0,1,22.679,5.4a3.1,3.1,0,0,1,.884.162L22.518,8.341a2.129,2.129,0,0,0-.72-.131,3.84,3.84,0,0,0-2.708,1.178,2.921,2.921,0,0,0-.949,2.578V22.154H15.591V9.61a8.25,8.25,0,0,0-.554-3.458",
    transform: "translate(2.601 0.934)",
    fill: "#3d3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13292",
    d: "M48.455,5.934l2.644-.42V22.136H48.455V5.934Z",
    transform: "translate(8.382 0.954)",
    fill: "#3d3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13294",
    d: "M68.393,5.934l2.646-.42V22.136H68.393V5.934Z",
    transform: "translate(11.831 0.954)",
    fill: "#3d3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13296",
    d: "M49.89,0a1.779,1.779,0,0,1,1.791,1.791,1.793,1.793,0,0,1-3.586.028A1.8,1.8,0,0,1,49.89,0",
    transform: "translate(8.319 0)",
    fill: "#5e7b9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13298",
    d: "M69.825,0a1.779,1.779,0,0,1,1.793,1.791,1.793,1.793,0,0,1-3.586.028A1.8,1.8,0,0,1,69.825,0",
    transform: "translate(11.768 0)",
    fill: "#5e7b9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13300",
    d: "M85.727,0A1.779,1.779,0,0,1,87.52,1.791a1.793,1.793,0,0,1-3.586.028A1.8,1.8,0,0,1,85.727,0",
    transform: "translate(14.519 0)",
    fill: "#5e7b9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13302",
    d: "M84.293,5.934l2.647-.42V22.136H84.293V5.934Z",
    transform: "translate(14.581 0.954)",
    fill: "#3d3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13304",
    d: "M30.513,5.4A6.438,6.438,0,0,1,36.1,8.245a10.3,10.3,0,0,1,1.5,6.037c0,5.426-2.907,8.3-6.989,8.3-4.477,0-7.025-3.3-7.025-8.655,0-5.3,2.649-8.524,6.928-8.524M30.48,7.491a3.716,3.716,0,0,0-3.334,1.765,9.076,9.076,0,0,0-.784,4.244,11.463,11.463,0,0,0,1.012,5.327,3.859,3.859,0,0,0,3.3,1.63A3.537,3.537,0,0,0,34.2,18.014a9.772,9.772,0,0,0,.488-3.537,11.494,11.494,0,0,0-.752-4.9,3.771,3.771,0,0,0-3.46-2.088",
    transform: "translate(4.08 0.934)",
    fill: "#3d3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13306",
    d: "M53.215,6.007l2.613-.551,3.791,11.2c.455,1.343.78,2.774.78,2.774h.067a23.126,23.126,0,0,1,.782-2.739L64.976,5.878h2.712l-6.11,16.432H59.064Z",
    transform: "translate(9.205 0.944)",
    fill: "#3d3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13308",
    d: "M82.587,6.6,81.8,8.523h-3.4V19.009c0,1.795.489,2.419,2.09,2.419a3.175,3.175,0,0,0,1.6-.331l.36,1.634a6.016,6.016,0,0,1-2.875.658,4.732,4.732,0,0,1-2.123-.46c-1.142-.552-1.567-1.6-1.567-3.232V8.523H73.766V6.6h2.254V1.811l2.408-.5V6.6Z",
    transform: "translate(12.76 0.227)",
    fill: "#3d3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13310",
    d: "M46.71,6.6l-.786,1.927h-3.4V19.009c0,1.795.488,2.419,2.09,2.419a3.171,3.171,0,0,0,1.6-.331l.362,1.634a6.018,6.018,0,0,1-2.876.658,4.735,4.735,0,0,1-2.123-.46c-1.142-.552-1.571-1.6-1.571-3.232V8.523H37.887V6.6h2.257V1.811l2.408-.5V6.6Z",
    transform: "translate(6.554 0.227)",
    fill: "#3d3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13312",
    d: "M90.347,7.673a1.81,1.81,0,1,1,3.616,0,1.809,1.809,0,1,1-3.616,0Zm-.392,0a2.2,2.2,0,1,0,2.2-2.2,2.186,2.186,0,0,0-2.2,2.2Zm3.122,1.206c-.047-.076-.249-.4-.354-.562-.083-.13-.156-.236-.21-.3a.871.871,0,0,0-.211-.223.63.63,0,0,0,.657-.676.653.653,0,0,0-.219-.5.781.781,0,0,0-.578-.178h-.687V8.879h.345V7.8a.281.281,0,0,1,.217.113,3.034,3.034,0,0,1,.427.608c.094.167.131.223.2.361ZM92.6,7.121a.465.465,0,0,1-.118.332.6.6,0,0,1-.423.114h-.238V6.714h.253a.777.777,0,0,1,.3.048.376.376,0,0,1,.226.359Z",
    transform: "translate(15.56 0.947)",
    fill: "#3d3e3e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.65d93454db9dc6cebfdc8b805cf29a5d.svg";
export { ForwardRef as ReactComponent };